import React, { useEffect, useState, Suspense, lazy } from "react";
import { HeadFC, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { queryResult } from "../../data/graphql/query";
import { getGatsbyImageNode } from "../../../utils/getGatsbyImageNode";

import LandingServiceGradientCardBg from "@flyvet/flyvet-react-library/dist/src/containers/landings/landing-service-gradient-card-bg";
// import Covenants from "@flyvet/flyvet-react-library/dist/src/containers/partners-grids/covenants";
import WhatsappButtonRounded from "@flyvet/flyvet-react-library/dist/src/components/buttons/whatsapp/whatsapp-button-rounded";
import WhatsFloatingButton from "@flyvet/flyvet-react-library/dist/src/components/buttons/whatsapp/whatsapp-floating-button";
import Seo from "@flyvet/flyvet-react-library/dist/src/containers/seos/seo-default";

import "../../styles/variables.scss";

export default function ServiceTemplate({ data }: any) {
  const { markdownRemark } = data; // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark;

  const ServiceContentImageText = lazy(
    () =>
      import(
        "@flyvet/flyvet-react-library/dist/src/containers/service-contents/service-content-image-text"
      )
  );

  const CallToAction = lazy(
    () =>
      import(
        "@flyvet/flyvet-react-library/dist/src/containers/call-to-actions/call-to-action"
      )
  );
  const ContactCompactGridAdress = lazy(
    () =>
      import(
        "@flyvet/flyvet-react-library/dist/src/containers/contact-grids/contact-compact-grid-address"
      )
  );
  const GoogleReviewsGridParallax = lazy(
    () =>
      import(
        "@flyvet/flyvet-react-library/dist/src/containers/google-reviews/google-reviews-grid-parallax"
      )
  );

  const ContactCompactGridNoMap = lazy(
    () =>
      import(
        "@flyvet/flyvet-react-library/dist/src/containers/contact-grids/contact-compact-grid-no-map"
      )
  );

  const {
    landingServiceImage,
    serviceLandingHeroImageTop,
    serviceLandingHeroImageBottom,
    whats,
    whatsMessage,
    address,
    agendamento,
    fixos,
    plantao,
    whatsContact,
    horarios,
    ctaImage,
    ctaTitle,
    mapsImage, googleCommentsObject,

  } = queryResult();

  const [pageLabel, setPageLabel] = useState("unknown");

  useEffect(() => {
    let path = window.location.pathname;
    if (path === "/") setPageLabel("home");
    else setPageLabel(window.location.pathname);
  }, []);

  let keywords = "";

  keywords +=
    ", " +
    frontmatter.title +
    ", " +
    frontmatter.title +
    " veterinária, " +
    frontmatter.title +
    " veterinário, " +
    frontmatter.title +
    " cachorro, " +
    frontmatter.title +
    " gato";

  const serviceUniqueImage = getImage(
    landingServiceImage.find((element: any) => {
      // Match string after final slash
      let regexString = `descricao\\.${frontmatter.imgSrc}\\-.*`;
      let regex = new RegExp(regexString);
      return element.node.original.src.split("/").pop().match(regex);
    }).node.gatsbyImageData
  )!;



  const renderButtonsContact = (trackEvent: any) => (
    <WhatsappButtonRounded
      whats={whats}
      whatsMsg={`Olá! Gostaria de agendar o serviço de ${frontmatter.title}.`}
      containerLabel="service_call_to_action"
      onClick={() => trackEvent({ action: "click_whatsapp" })}
      buttonText="Clique para agendar"
    ></WhatsappButtonRounded>
  );
  const renderButtons = (trackEvent: any) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
        alignItems: "center",
      }}
    >
      <WhatsappButtonRounded
        whats={whats}
        whatsMsg={whatsMessage}
        buttonText="Consultas"
        containerLabel="landing_home"
      ></WhatsappButtonRounded>
      {/* <WhatsappButtonRounded
        whats={"5511972774783"}
        whatsMsg={
          "Olá! Vim pelo site e gostaria de saber mais sobre o banho e tosa."
        }
        buttonText="Banho e Tosa"
        containerLabel="landing_home"
      ></WhatsappButtonRounded> */}
    </div>
  );
  return (
    <main>
      <WhatsFloatingButton
        containerLabel="floating-button"
        whats={whats}
      ></WhatsFloatingButton>

      <LandingServiceGradientCardBg
        imageBg1={getGatsbyImageNode(
          serviceLandingHeroImageTop,
          `${frontmatter.title} Landing Hero Top Image`,
          false,
          false,
          false
        )}
        imageBg2={getGatsbyImageNode(
          serviceLandingHeroImageBottom,
          `${frontmatter.title} Landing Hero Bottom Image`,
          false,
          false,
          false
        )}
        serviceType={"Carinho e Cuidado"}
        title={frontmatter.title}
        subtitle={frontmatter.subtitle}
        ctaText="Reserve agora e proporcione momentos felizes para o seu fiel companheiro!"
        renderButtons={renderButtonsContact}
        whats={whats}
      ></LandingServiceGradientCardBg>

      {/* <Covenants logos={covenantsImagesFormatted} /> */}

      <Suspense
        fallback={
          <h2
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "200px",
              height: "400px",
              background: "rgba(1, 1, 1, 1)",
            }}
          >
            Loading...
          </h2>
        }
      >
        <ServiceContentImageText
          contentText={html}
          contentImage={getGatsbyImageNode(
            serviceUniqueImage,
            `${frontmatter.title} Landing Image`,
            false,
            true,
            true
          )}
          contentTitle={frontmatter.title}
        ></ServiceContentImageText>

        <CallToAction
          background={getGatsbyImageNode(ctaImage, "Call to Action Image", false, true, true)}
          renderButtons={renderButtonsContact}
          title={ctaTitle}
          renderText={() => (
            <p>
              Conheça nossos serviços e fique à vontade para tirar quaisquer
              dúvidas.
            </p>
          )}
        ></CallToAction>

        <GoogleReviewsGridParallax
          comments={googleCommentsObject}
          hasColorfulCards
        ></GoogleReviewsGridParallax>

        <ContactCompactGridAdress
          mapImage={getGatsbyImageNode(mapsImage, "Call to Action Image")}
          endereco={address}
          agendamento={agendamento}
          fixos={fixos[0] === "" ? [] : fixos}
          plantao={plantao}
          horarios={horarios}
          whatsLabels={["WhatsApp Consultas:"]}
          // whatsLabels={["WhatsApp Consultas:", "WhatsApp Banho e Tosa:"]}
          whats={whatsContact}
          whatsMsg={[
            "Olá! Vim pelo site e gostaria de saber mais sobre as consultas.",
            // "Olá! Vim pelo site e gostaria de saber mais sobre o banho e tosa.",
          ]}
          renderButtons={renderButtons}
        ></ContactCompactGridAdress>
      </Suspense>
    </main>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        path
        title
        subtitle
        desc
        imgSrc
      }
    }
    seo: allFile(filter: { name: { eq: "seo.metadata" } }) {
      edges {
        node {
          childHeadJson {
            meta {
              keywords
              url
              Classification
              og_title
              og_type
              og_url
              og_site_name
              og_street_address
              og_locality
              og_region
              og_postal_code
              og_country_name
            }
          }
        }
      }
    }
  }
`;

export const Head: HeadFC<{ markdownRemark: any; seo: any }> = ({ data }) => (
  <>
    <html lang="pt-BR" />
    <Seo
      title={`${data.markdownRemark.frontmatter.title} | ${data.seo.edges[0].node.childHeadJson.meta.og_title}`}
      description={data.markdownRemark.frontmatter.subtitle}
      og_description={data.markdownRemark.frontmatter.subtitle}
      {...data.seo.edges[0].node.childHeadJson.meta}
      og_title={`${data.markdownRemark.frontmatter.title} | ${data.seo.edges[0].node.childHeadJson.meta.og_title}`}
    ></Seo>
  </>
);
